//Used on all pages
import Rails from '@rails/ujs';
import Turbolinks from 'turbolinks';
import * as ActiveStorage from '@rails/activestorage';
import 'channels';
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
import '../stylesheets/common';

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

const feather = require('feather-icons')
document.addEventListener('turbolinks:load', () => {
  feather.replace({ 'stroke-width': 1.5 });
})

Rails.start()
Turbolinks.start()
ActiveStorage.start()